import { BulkItemRunWithPosition } from "./types";

export const getRunLink = (item: BulkItemRunWithPosition) => {
  const group = item.isModule ? "module" : "stack";

  return `/${group}/${item.stackId}/run/${item.id}`;
};
